module.exports = __webpack_public_path__ + "img/invalid.377701db.png";